import { resolveProductImage } from "@/lib/functions";

/** Maps CMS ProductConfRecord to the slide shape used by related-product cards. */
export function mapShowcaseEntryToSlide(entry: any) {
  const product = entry?.product;
  if (!product?.slug) return null;

  const previewImage = entry?.previewImage?.responsiveImage
    ? { responsiveImage: entry.previewImage.responsiveImage }
    : null;

  const factSheetImage = previewImage || resolveProductImage(product);

  const brandName =
    entry?.customBrandLabel?.label ?? product.productBrand?.title;
  const productName =
    entry?.customLabel?.label ||
    (entry?.productNameLabel === "brand" ? brandName : product.productName);

  return {
    id: entry?.id ?? product.id,
    __typename: product.__typename,
    slug: product.slug,
    productTypeSpecific: product.productTypeSpecific,
    brandName,
    productName,
    factSheetImage,
    sku: product.sku,
    hideCallToAction: entry?.hideCallToAction,
    geo: entry?.geo,
  };
}
